import { FC } from "react";
import { Icon } from "@/components/Common/Icon";
import { IconNames } from "@/types/v2";
import { cn } from "@/lib/utils";
import { SortIndicatorProps } from "../types";

export const SortIndicator: FC<SortIndicatorProps> = ({
  direction,
  priority,
  isActive,
}) => {
  if (!isActive) {
    return (
      <div className="ml-2 flex h-4 w-4 items-center justify-center text-primary-foreground opacity-30">
        <Icon name={IconNames.sort} size={18} />
      </div>
    );
  }

  return (
    <div className="ml-2 flex items-center space-x-1">
      <Icon
        name={direction === "asc" ? IconNames.upArrow : IconNames.downArrow}
        className={cn(
          "transition-colors",
          isActive ? "text-primary-foreground" : "text-muted-foreground"
        )}
        size={18}
      />
      {priority !== undefined && priority > 0 && (
        <span className="flex h-4 w-4 items-center justify-center rounded-full bg-primary text-xs text-primary-foreground">
          {priority + 1}
        </span>
      )}
    </div>
  );
};
